<template>
  <div
    class="pa-3"
    style="
      background-color: aliceblue;
      border-style: solid;
      margin-bottom: 10px;
    "
  >
    <!-- Item number and delete button -->
    <v-row>
      <v-col cols="1" class="pt-2 pl-6">
        <span
          style="
            font-size: 20px !important;
            font-weight: bold !important;
          "
        >
          {{ index + 1 }}.
        </span>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="pr-4 pb-0 pt-0" align="right">
        <v-btn icon @click="$emit('remove')">
          <v-icon color="red" medium>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Item search combobox -->
    <v-row dense>
      <v-col cols="12">
        <v-combobox
          ref="itemCombobox"
          outlined
          dense
          :search-input="searchKeyword"
          @update:search-input="$emit('update:searchKeyword', $event)"
          :value="selectedItem"
          @input="$emit('update:selectedItem', $event)"
          @change="$emit('item-change', $event)"
          :items="items"
          :loading="isLoading"
          hide-no-data
          hide-selected
          item-text="data.searchName"
          item-value="data.id"
          label="Artikl"
          placeholder="Pocnite tipkati za pretragu"
          :disabled="disabled"
          return-object
          append-icon=""
          :error="validationErrors.name"
        >
          <template v-slot:selection="{ item }">
            <span v-if="typeof item === 'string'">{{ item }}</span>
            <span v-else-if="item && item.data && item.data.name">{{ item.data.name }}</span>
          </template>
          <template v-slot:item="{ item }">
            <template>
              <v-list-item-avatar>
                <img
                  v-if="item.data && item.data.picture"
                  :src="item.data.picture"
                />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  {{ item.data && item.data.name ? item.data.name.toUpperCase() : '' }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ getCategory(item) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ item.data && item.data.code ? item.data.code : '' }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                {{ showItemPrice(item) }}
              </v-list-item-action>
            </template>
          </template>
        </v-combobox>
      </v-col>
    </v-row>

    <!-- Item details: unit, tax, quantity, price, discount, KPD -->
    <v-row dense style="margin-top: -1rem">
      <v-col cols="2">
        <v-combobox
          dense
          outlined
          :value="cartItem.unit"
          @input="$emit('update-unit', $event)"
          :items="cartItem.units"
          label="Jed. mjere"
          item-text="storageUnit"
          item-value="price[currency].price"
          return-object
          :disabled="!cashRegister"
          hide-details
          :error="validationErrors.unit"
        ></v-combobox>
      </v-col>
      <v-col cols="2">
        <v-select
          dense
          outlined
          :value="cartItem.tax"
          @input="$emit('update-tax', $event)"
          :label="taxLabel"
          :items="taxes"
          item-text="name"
          item-value="rate"
          :disabled="!cashRegister"
          return-object
          hide-details
          :placeholder="cartItem.tax ? '' : 'Odaberite'"
          :error="validationErrors.tax"
        >
          <template v-slot:selection="{ item }">
            <span v-if="item && item.name">{{ item.name }}</span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="2">
        <v-text-field
          outlined
          dense
          :value="cartItem.formattedQuantity"
          @input="$emit('update-quantity-input', $event)"
          @blur="$emit('update-quantity-blur', $event)"
          @focus="$event.target.select()"
          hide-spin-buttons
          type="number"
          label="Količina"
          suffix="x"
          min="0"
          :disabled="!cashRegister"
          hide-details
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          dense
          outlined
          type="number"
          hide-spin-buttons
          :value="cartItem.formattedPrice"
          @input="$emit('update-price-input', $event)"
          @blur="$emit('update-price-blur', $event)"
          @focus="$event.target.select()"
          label="Cijena"
          min="0"
          :disabled="!cashRegister"
          :suffix="currencySymbol"
          hide-details
          :error="validationErrors.price"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          dense
          outlined
          hide-spin-buttons
          :value="cartItem.formattedDiscount"
          @input="$emit('update-discount-input', $event)"
          @blur="$emit('update-discount-blur', $event)"
          @focus="$event.target.select()"
          type="number"
          label="Popust"
          suffix="%"
          min="0"
          :disabled="!cashRegister"
          hide-details
        >
        </v-text-field>
      </v-col>
      <v-col cols="2" v-if="eracun">
        <v-text-field
          dense
          outlined
          :value="cartItem.kpdcode"
          @input="$emit('update-kpdcode', $event)"
          label="KPD Šifra"
          :disabled="!cashRegister"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Tax category and exemption reason for 0% VAT items when eRacun is enabled -->
    <v-row
      v-if="eracun && cartItem.tax && cartItem.tax.rate === 0"
      dense
      style="margin-top: 0.5rem"
      class="pb-2"
    >
      <v-col cols="6">
        <v-select
          dense
          outlined
          :value="cartItem.taxCategory"
          @input="$emit('update-tax-category', $event)"
          label="Kategorija poreza"
          :items="taxCategories"
          item-text="name"
          item-value="value"
          :disabled="!cashRegister"
          hide-details
          return-object
        ></v-select>
      </v-col>
      <v-col cols="6">
        <v-select
          dense
          outlined
          :value="cartItem.taxExemptionReason"
          @input="$emit('update-tax-exemption-reason', $event)"
          label="Razlog oslobođenja od poreza"
          :items="taxExemptionReasons"
          item-text="name"
          item-value="value"
          :disabled="!cashRegister"
          hide-details
          return-object
        ></v-select>
      </v-col>
    </v-row>

    <!-- Item type radio buttons for free items -->
    <v-row
      v-if="cartItem.data.freeItem === true"
      class="pt-0 mt-0"
    >
      <v-col
        cols="12"
        class="d-flex pt-2 pb-2 mt-0 py-0 justify-end"
      >
        <v-radio-group
          class="pt-0 mt-0 small-radio"
          row
          :value="cartItem.data.type"
          @input="$emit('update-item-type', $event)"
          :rules="[(v) => !!v || 'Molimo odaberite']"
          required
          hide-details
          dense
        >
          <v-radio
            v-for="type in itemTypes"
            :key="type.value"
            :value="type.value"
            :label="type.name"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CartItem',
  props: {
    cartItem: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    searchKeyword: {
      type: String,
      default: ''
    },
    selectedItem: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cashRegister: {
      type: Object,
      default: null
    },
    taxes: {
      type: Array,
      required: true
    },
    taxLabel: {
      type: String,
      required: true
    },
    currencySymbol: {
      type: String,
      required: true
    },
    eracun: {
      type: Boolean,
      default: false
    },
    taxCategories: {
      type: Array,
      default: () => []
    },
    taxExemptionReasons: {
      type: Array,
      default: () => []
    },
    itemTypes: {
      type: Array,
      required: true
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    focus () {
      // Metoda za fokusiranje combobox-a izvana
      if (this.$refs.itemCombobox) {
        this.$refs.itemCombobox.focus()
      }
    },
    getCategory (item) {
      // Method will be passed from parent or can be duplicated here
      if (!item || !item.data) return ''
      return item.data.category || ''
    },
    showItemPrice (item) {
      // Method will be passed from parent or can be duplicated here
      if (!item || !item.data || !item.data.price) return ''
      return item.data.price
    }
  }
}
</script>
